import React, { useEffect, useState } from "react";
import "./StudentPerformance.css";
import DatePicker from "react-datepicker";
import axios from "./../axios";

import { format } from "date-fns";
import PerformanceSummaryPage from "./StudentPerformanceChart/PerformanceSummary/PerformanceSummaryPage";
import CognitiveThinkingPage from "./CognitiveThinkingPage/CognitiveThinkingPage";
import ClassRankingPage from "./ClassRankingPage/ClassRankingPage";
import ClassAnalysis from "./ClassAnalysis/ClassAnalysis";
import ExportStudentPDF from "./ExportStudentPDF/ExportStudentPDF";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRotateRight } from "@fortawesome/free-solid-svg-icons";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  IconButton,
} from "@mui/material";

let dummyArr = [{}];
function StudentPerformance({ leftSidebarSize }) {
  const schoolId = JSON.parse(localStorage.getItem("schoolId"));
  const academic_year_id = JSON.parse(localStorage.getItem("academicYearId"));
  const academicSession = JSON.parse(
    localStorage.getItem("academicYearSessionId"),
  );
  const timeTableSessionId = JSON.parse(
    localStorage.getItem("timeTableSessionId"),
  );
  const UserInformationData = JSON.parse(
    localStorage.getItem("UserInformation"),
  );

  const [selectedTimeTableSession, setSelectedTimeTableSession] = useState();
  const [academicSessionId, setAcademicSessionId] = useState();
  const [classId, setClassId] = useState(null);
  const [sectionId, setSectionId] = useState(null);
  const [studentAdmissionId, setstudentAdmissionId] = useState("");
  const [filteredStudents, setFilteredStudents] = useState([]);
  const [showTable, setShowTable] = useState(false);
  const [date, setDate] = useState(new Date());
  const [student, setStudent] = useState(null);
  const [studentData, setStudentData] = useState([]);
  const [subjectData, setSubjectData] = useState([]);
  const [academicYear, setAcademicYear] = useState(null);
  const [assessmentTypeId, setAssessmentTypeId] = useState("");
  const [assessmentData, setAssessmentData] = useState([]);
  const [enableSubmitBtn, setEnableSubmitBtn] = useState(true);
  const [isDateChanged, setIsDateChanged] = useState(false);
  const [dropdownLists, setDropdownLists] = useState({
    standards: null,
    sections: null,
  });
  const [subjectWiseData, setSubjectWiseData] = useState([]);
  const [dateError, setDateError] = useState(false);
  const { standards, sections } = dropdownLists;
  const standardList = [];
  const sectionList = [];
  const CTRole_Information = JSON.parse(
    localStorage.getItem("role_as_class_teacher"),
  );
  const CoRole_Information = JSON.parse(
    localStorage.getItem("role_as_co_ordinator"),
  );

  const safeParse = (key, defaultValue = []) => {
    try {
      const value = localStorage.getItem(key);
      if (!value) return defaultValue;
      return JSON.parse(value);
    } catch (e) {
      console.warn(`Invalid JSON in localStorage for key: ${key}`);
      return defaultValue;
    }
  };

  let generalRole_JSON = safeParse("general_role", []);
  let classTeacher_JSON = safeParse("role_as_class_teacher", []);
  let cordinator_JSON = safeParse("role_as_co_ordinator", []);

  const [subjectList, setSubjectList] = useState({
    subjectName: [],
  });
  const { allSubjectList } = subjectList;
  const [selectedOptions, setSelectedOptions] = useState([]);

  useEffect(() => {
    const fetchAcademicYear = async () => {
      if (!schoolId) return;
      try {
        const response = await axios.get(
          `api/v1/school/academicYear/list/get/school/${schoolId}`,
        );
        console.log(response, "response of acdemic year id");
        response.data.data.filter((item) => {
          if (item.id === academic_year_id) {
            setAcademicYear(item);
          }
        });
      } catch (err) {
        console.log("Error", err);
      }
    };

    fetchAcademicYear();
  }, [schoolId]);

  const StartAcademicYear = academicYear?.start_date;
  const EndAcademicYear = academicYear?.end_date;

  let sectionArr = [];
  let standardArr = [];

  const dropDownHelper = () => {
    function addUniqueObjectToArraystand(obj) {
      if (
        !standardArr.some(
          (item) => JSON.stringify(item) === JSON.stringify(obj),
        )
      ) {
        standardArr.push(obj);
      }
    }
    CTRole_Information?.map((obj) =>
      addUniqueObjectToArraystand(obj.standard_id),
    );
    CoRole_Information?.map((obj) =>
      addUniqueObjectToArraystand(obj.standard_id),
    );
  };

  dropDownHelper();

  const handleDropDownSec = () => {
    function addUniqueObjectToArraysect(obj) {
      if (
        !sectionArr.some((item) => JSON.stringify(item) === JSON.stringify(obj))
      ) {
        sectionArr.push(obj);
      }
    }
    CTRole_Information?.map((obj) => {
      if (obj?.standard_id?.id === classId) {
        addUniqueObjectToArraysect(obj.section_id);
      }
    });
    CoRole_Information?.map((obj) => {
      if (obj?.standard_id?.id === classId) {
        addUniqueObjectToArraysect(obj.section_id);
      }
    });
  };
  handleDropDownSec();

  useEffect(() => {
    const getsubjectList = async () => {
      dummyArr = [];
      try {
        function addUniqueObjectToArray(obj) {
          if (
            !dummyArr.some(
              (item) => JSON.stringify(item) === JSON.stringify(obj),
            )
          ) {
            dummyArr.push(obj);
          }
        }
        if (classTeacher_JSON.length > 0) {
          let res = await axios.get(
            `/api/v1/school/standardId/${classTeacher_JSON[0]?.standard_id?.id}/sectionId/${classTeacher_JSON[0]?.section_id?.id}/getSubjects`,
          );
          const subjectSource =
            res?.data?.data?.subjectConfigurations?.length > 0
              ? res.data.data.subjectConfigurations.map((item) => item.subject)
              : res.data.data.subjects;

          subjectSource.forEach((obj) => addUniqueObjectToArray(obj));
        }

        if (cordinator_JSON.length > 0) {
          let res = await axios.get(
            `/api/v1/school/standardId/${cordinator_JSON[0]?.standard_id?.id}/sectionId/${cordinator_JSON[0]?.section_id?.id}/getSubjects`,
          );
          const subjectSource =
            res?.data?.data?.subjectConfigurations?.length > 0
              ? res.data.data.subjectConfigurations.map((item) => item.subject)
              : res.data.data.subjects;

          subjectSource.forEach((obj) => addUniqueObjectToArray(obj));
        }

        if (generalRole_JSON.length > 0) {
          generalRole_JSON.forEach((obj) => {
            obj?.subjects_id?.forEach((para) => {
              addUniqueObjectToArray(para);
            });
          });
        }

        setSubjectList({
          allSubjectList: dummyArr,
        });
      } catch (error) {
        console.log(error);
      }
    };

    getsubjectList();
  }, []);

  console.log("allSubjectList", allSubjectList);

  useEffect(() => {
    const fetchStudentData = async () => {
      if (!schoolId) return;
      try {
        const response = await axios.get(
          `api/v1/school/student/get/school/${schoolId}`,
        );
        setStudentData(response?.data?.data);
      } catch (err) {
        console.log("Error", err);
      }
    };

    fetchStudentData();
  }, [schoolId]);

  useEffect(() => {
    const fetchSubject = async () => {
      try {
        const response = await axios.get(
          `api/v1/school/standardSection/get/school/standards/${schoolId}`,
        );
        setSubjectData(response?.data?.data);
      } catch (err) {
        console.log("Error", err);
      }
    };
    fetchSubject();
  }, [schoolId]);

  useEffect(() => {
    const fetchAssessmentType = async () => {
      try {
        const response = await axios.get(
          `api/v1/performance/assessment-events?schoolId=${schoolId}`,
        );
        setAssessmentData(response?.data?.data);
      } catch (err) {
        console.log("Error", err);
      }
    };
    fetchAssessmentType();
  }, [schoolId]);

  const matchedSubjects = subjectData
    ?.filter(
      (entry) =>
        entry.academicYearSessions?._id === academicSession &&
        entry?.timetableSessions?.id === timeTableSessionId &&
        entry.standard?.id === classId &&
        entry.section?.id === sectionId,
    )
    .flatMap((entry) => entry.subjects || []);

  const minDate = academicYear ? new Date(academicYear?.start_date) : 0;

  const maxDate = academicYear ? new Date(academicYear?.end_date) : 0;

  const [dateRange, setDateRange] = useState([minDate, maxDate]);

  const academicStart = academicYear
    ? new Date(academicYear?.start_date).getTime()
    : 0;
  const academicEnd = academicYear
    ? new Date(academicYear?.end_date).getTime()
    : 0;

  const startDateProp = new Date(dateRange[0])?.toISOString()?.split("T")[0];
  const endDateProp = new Date(dateRange[1])?.toISOString()?.split("T")[0];

  useEffect(() => {
    if (!academicYear) return;
    if (academicYear) {
      const SutcDate = StartAcademicYear;
      const EutcDate = EndAcademicYear;
      const date1 = new Date(SutcDate).toString();
      const date2 = new Date(EutcDate).toString();

      setDateRange([new Date(date1).getTime(), new Date(date2).getTime()]);
    }
  }, [academicYear]);

  useEffect(() => {
    if (!classId || !sectionId) {
      setFilteredStudents([]);
      return;
    }

    const filtered = studentData?.filter((student) => {
      return (
        student?.standard?.id === classId &&
        student?.section?.id === sectionId &&
        student?.academicYear?.id === academic_year_id &&
        student?.academicYearSession?._id === academicSession &&
        student?.timetableSession?.id === timeTableSessionId
      );
    });

    setFilteredStudents(filtered);
  }, [
    classId,
    sectionId,
    studentData,
    academic_year_id,
    academicSession,
    timeTableSessionId,
  ]);

  console.log("studentData", studentData);
  useEffect(() => {
    const selectedStudent = studentData?.find(
      (student) => student?.id === studentAdmissionId,
    );
    setStudent(selectedStudent);
  }, [studentAdmissionId]);

  const handleClassChange = (value) => {
    setClassId(value);
    setShowTable(false);
    setSectionId("");
    setstudentAdmissionId("");
  };

  const handleSectionChange = (value) => {
    setSectionId(value);
    setstudentAdmissionId("");
    setShowTable(false);
  };

  useEffect(() => {
    if (!startDateProp || !endDateProp || !student?.id) return;

    const fetchSubjectWiseData = async () => {
      try {
        const response = await axios.get(
          `api/v1/performance/student/${student?.id}/subjectWisePercentage/get?startDate=${startDateProp}&endDate=${endDateProp}&assessmentEventId=${assessmentTypeId}`,
        );
        setSubjectWiseData(response?.data?.data);
      } catch (error) {
        console.log("error", error);
      }
    };
    fetchSubjectWiseData();
  }, [student, startDateProp, endDateProp, assessmentTypeId]);

  const getOrdinal = (day) => {
    if (day > 3 && day < 21) return "th";
    switch (day % 10) {
      case 1:
        return "st";
      case 2:
        return "nd";
      case 3:
        return "rd";
      default:
        return "th";
    }
  };

  const formatDate = (timestamp) => {
    const date = new Date(timestamp);
    const day = date.getDate();
    const month = format(date, "MMM"); // Apr
    const year = date.getFullYear();
    return `${day}${getOrdinal(day)} ${month} ${year}`;
  };

  useEffect(() => {
    if (
      !classId ||
      !sectionId ||
      !studentAdmissionId ||
      studentAdmissionId === "null"
    ) {
      setEnableSubmitBtn(true);
    } else {
      setEnableSubmitBtn(false);
    }
  }, [classId, sectionId, studentAdmissionId]);

  const formatDateForInput = (timestamp) => {
    const date = new Date(timestamp);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
  };

  const handleDateInputChange = (index, value) => {
    const newDate = value ? new Date(value).getTime() : dateRange[index];
    const updatedDateRange = [...dateRange];
    updatedDateRange[index] = newDate;

    // Validation: End date cannot be before start date
    const [start, end] = updatedDateRange;
    if (start && end && end < start) {
      setDateError("End date cannot be before Start date.");
    } else {
      setDateError(null);
      setDateRange(updatedDateRange);
      setIsDateChanged(true);
      setShowTable(false);
    }
  };
  return (
    <div
      className={` scroll-area ${
        leftSidebarSize === 70 ? "expand" : "collapsess"
      }`}
    >
      <div className="main-container">
        <div className="card">
          <div className="card-content">
            {/* Class */}
            <FormControl size="small" fullWidth sx={{ width: 150 }}>
              <InputLabel>Class*</InputLabel>
              <Select
                label="Class*"
                value={classId || ""}
                onChange={(e) => handleClassChange(e.target.value)}
              >
                <MenuItem value="null">Select Class</MenuItem>
                {standardArr?.length > 0 &&
                  [...standardArr]
                    .sort((a, b) => {
                      const aNum = Number(a.name);
                      const bNum = Number(b.name);

                      const bothNumeric = !isNaN(aNum) && !isNaN(bNum);
                      if (bothNumeric) {
                        return aNum - bNum; // numeric sort
                      }

                      return a.name.localeCompare(b.name); // alphabetical sort
                    })
                    .map((standard, index) => (
                      <MenuItem
                        key={index}
                        value={standard?.id}
                        name={standard?.name}
                      >
                        {standard?.name}
                      </MenuItem>
                    ))}
              </Select>
            </FormControl>

            {/* Section */}
            <FormControl size="small" fullWidth sx={{ width: 150 }}>
              <InputLabel>Section*</InputLabel>
              <Select
                label="Section*"
                value={sectionId || ""}
                onChange={(e) => handleSectionChange(e.target.value)}
              >
                <MenuItem value="null">Select Section</MenuItem>
                {sectionArr
                  ?.slice()
                  .sort((a, b) => a.name.localeCompare(b.name))
                  .map((s) => (
                    <MenuItem key={s.id} value={s.id}>
                      {s.name}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>

            {/* Admission Number */}
            <FormControl size="small" fullWidth sx={{ width: 230 }}>
              <InputLabel>Student Admission No. *</InputLabel>
              <Select
                label="Student Admission No. *"
                value={studentAdmissionId || ""}
                onChange={(e) => {
                  setstudentAdmissionId(e.target.value);
                  setShowTable(false);
                }}
              >
                <MenuItem value="null">Select Admission No.</MenuItem>
                {filteredStudents?.map((s) => (
                  <MenuItem key={s.id} value={s.id}>
                    {s.name} | {s.admissionNumber}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            {/* Date Range */}
            <DatePicker
              selected={dateRange[0]}
              onChange={(d) => {
                handleDateInputChange(0, d);
                setShowTable(false);
              }}
              dateFormat="dd/MM/yyyy"
              placeholderText="Start Date"
              className="form-control"
              style={{ width: 100 }}
            />
            <DatePicker
              selected={dateRange[1]}
              onChange={(d) => {
                handleDateInputChange(1, d);
                setShowTable(false);
              }}
              dateFormat="dd/MM/yyyy"
              placeholderText="End Date"
              className="form-control"
              style={{ width: 100 }}
            />

            {/* Assessment Type */}
            <div className="d-flex align-items-center gap-2">
              <FormControl size="small" fullWidth sx={{ width: 200 }}>
                <InputLabel>Assessment Event</InputLabel>
                <Select
                  label="Assessment Event"
                  value={assessmentTypeId || ""}
                  onChange={(e) => {
                    setAssessmentTypeId(e.target.value);
                    setShowTable(false);
                  }}
                >
                  {/* <MenuItem value="null">Select Assessment Event</MenuItem> */}
                  {assessmentData.map((t) => (
                    <MenuItem key={t._id} value={t._id}>
                      {t.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <IconButton
                onClick={() => setAssessmentTypeId("")}
                title="Reset"
                size="small"
              >
                <FontAwesomeIcon icon={faRotateRight} />
              </IconButton>
            </div>
          </div>

          {/* <div className="container">
            <div className="sub-container">
              <div className="months-container">
                {orderedMonths.map((month) => (
                  <span key={month} className="month-badge">
                    {month}
                  </span>
                ))}
              </div>

              <div className="slider-wrapper">
                <input
                  type="range"
                  min={academicStart}
                  max={academicEnd}
                  value={dateRange[0]}
                  step={24 * 60 * 60 * 1000}
                  onChange={(e) =>
                    handleSliderChange([+e.target.value, dateRange[1]])
                  }
                  className="slider"
                />

                <div
                  className="end-circle"
                  style={{
                    left: `${
                      ((dateRange[1] - academicStart) /
                        (academicEnd - academicStart)) *
                      100
                    }%`,
                    transform: "translateX(-50%)",
                  }}
                />
              </div>
            </div>

            <div className="labels-wrapper">
              <span
                className="date-label"
                style={{
                  left: `${
                    ((clamp(dateRange[0], academicStart, academicEnd) -
                      academicStart) /
                      (academicEnd - academicStart)) *
                    100
                  }%`,
                  transform: "translateX(-50%)",
                }}
              >
                {formatDate(dateRange[0])}
              </span>
              <span
                className="date-label"
                style={{
                  left: `${
                    ((clamp(dateRange[1], academicStart, academicEnd) -
                      academicStart) /
                      (academicEnd - academicStart)) *
                    100
                  }%`,
                  transform: "translateX(-50%)",
                }}
              >
                {formatDate(dateRange[1])}
              </span>
            </div>
          </div> */}
          {!enableSubmitBtn && (
            <div className="card-footer">
              <button
                className="showTablebutton"
                onClick={() => setShowTable(true)}
              >
                Get Student Performance
              </button>
              <ExportStudentPDF
                student={student}
                startDate={startDateProp}
                endDate={endDateProp}
                subjects={matchedSubjects}
                assessmentTypeId={assessmentTypeId}
                studentAdmissionId={studentAdmissionId}
                matchedSubjects={matchedSubjects}
                assessmentData={assessmentData}
              />
              {console.log(studentAdmissionId, "studentAdmissionId")}
            </div>
          )}
        </div>
        {showTable && (
          <div className="table-scroll orange-scrollBar">
            <div>
              {/* Render performance components */}
              <PerformanceSummaryPage
                student={student}
                startDate={startDateProp}
                endDate={endDateProp}
                subjects={matchedSubjects}
                assessmentTypeId={assessmentTypeId}
                subjectWiseData={subjectWiseData}
                allSubjectList={allSubjectList}
              />
              <CognitiveThinkingPage
                student={student}
                startDate={startDateProp}
                endDate={endDateProp}
                subjects={matchedSubjects}
                assessmentTypeId={assessmentTypeId}
                subjectWiseData={subjectWiseData}
                allSubjectList={allSubjectList}
              />
              <ClassRankingPage
                student={student}
                startDate={startDateProp}
                endDate={endDateProp}
                subjects={matchedSubjects}
                assessmentTypeId={assessmentTypeId}
                subjectWiseData={subjectWiseData}
                allSubjectList={allSubjectList}
              />
              <ClassAnalysis
                student={student}
                startDate={startDateProp}
                endDate={endDateProp}
                subjects={matchedSubjects}
                assessmentTypeId={assessmentTypeId}
                subjectWiseData={subjectWiseData}
                allSubjectList={allSubjectList}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default StudentPerformance;
